import { useQuery, useQueryClient } from "@tanstack/react-query";

import { ExecuteData, useApi } from "../../useApi";

import { UseGetTermDataDraftResponse } from "./use-get-term-data-draft.types";

import { useAuth } from "@/core/libs/use-auth";

const QUERY_TOKEN = "term-draft-data";

export const useGetTermDataDraft = (
  contractId: number
): UseGetTermDataDraftResponse => {
  const { execute } = useApi();
  const { isAuthenticated } = useAuth();
  const queryClient = useQueryClient();

  const fetchData = () => {
    const data: ExecuteData = {
      url: `term-data-draft/${contractId}`,
      method: "GET",
      notificationMessage: `Buscando informações do termo relacionados ao contrato ${contractId}`
    };

    return execute(data);
  };

  const { data, isFetching } = useQuery({
    queryKey: [QUERY_TOKEN, contractId],
    queryFn: () => fetchData(),
    enabled: isAuthenticated,
    staleTime: 120000,
    placeholderData: prev => prev
  });

  const invalidateQuery = () => {
    queryClient.invalidateQueries({ queryKey: [QUERY_TOKEN] });
  };

  return {
    list: data?.data,
    isLoadingList: isFetching,
    invalidateQuery
  };
};
